import { render, staticRenderFns } from "./forbidenGoods.vue?vue&type=template&id=51f66b82&scoped=true"
import script from "./forbidenGoods.vue?vue&type=script&lang=js"
export * from "./forbidenGoods.vue?vue&type=script&lang=js"
import style0 from "./forbidenGoods.vue?vue&type=style&index=0&id=51f66b82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f66b82",
  null
  
)

export default component.exports